// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const BoxMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M2.5 14.2583V5.74148C2.5 5.54389 2.61637 5.36483 2.79693 5.28458L9.79692 2.17346C9.92625 2.11601 10.0737 2.11601 10.2031 2.17346L17.2031 5.28458C17.3837 5.36483 17.5 5.54389 17.5 5.74148V14.2583C17.5 14.4559 17.3837 14.635 17.2031 14.7152L10.2031 17.8263C10.0737 17.8837 9.92625 17.8837 9.79692 17.8263L2.79693 14.7152C2.61637 14.635 2.5 14.4559 2.5 14.2583Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 5.5L10 9M10 9L2.5 5.5M10 9V18" stroke={color} strokeWidth="1.5" />
        <path d="M6.25 3.75L13.4531 6.95137C13.6337 7.03162 13.75 7.21068 13.75 7.40827V10.4167" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
